import React from "react";
import ReactDOM from "react-dom/client";
import "@engie-group/fluid-design-tokens/lib/css/tokens.css";
import '@engie-group/fluid-design-system-react/css';
import "./styles/global.css";
import { loadConfig } from "./config/loader.ts";

loadConfig().then(async () => {
  const { default: App } = await import("./App.tsx");
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}).catch((error) => {
  console.error('[Config] Failed to load configuration:', error);
  document.getElementById("root")!.innerHTML = `
    <div style="display: flex; align-items: center; justify-content: center; height: 100vh; font-family: system-ui;">
      <div style="text-align: center;">
        <h1>Configuration Error</h1>
        <p>Failed to load application configuration. Please refresh or contact support.</p>
      </div>
    </div>
  `;
});
